import type { MemberRemoval } from '@/lib/api/generated/model';

/** What a removal cleared, as one sentence for the toast (spec 153 FR-004). */
export function removalSentence(
  name: string,
  removal: MemberRemoval,
  left: boolean,
): string {
  const cleared: string[] = [];
  if (removal.gate_assignments_cleared > 0) {
    cleared.push(
      `${String(removal.gate_assignments_cleared)} gate assignment${removal.gate_assignments_cleared === 1 ? '' : 's'}`,
    );
  }
  if (removal.step_assignees_cleared > 0) {
    cleared.push(
      `${String(removal.step_assignees_cleared)} workflow step${removal.step_assignees_cleared === 1 ? '' : 's'}`,
    );
  }
  const head = left ? 'You left the workspace' : `${name} was removed`;
  return cleared.length > 0
    ? `${head}. Cleared: ${cleared.join(', ')}.`
    : `${head}.`;
}
